import { useJobCardTracking } from '../../cards/job-card/use-job-card-tracking';
import { useSearchAndShuffleContext } from '../../context';

type UseErrorHandlerReturn = {
  triggerError: (params: ErrorParams) => void;
};

type ErrorParams = {
  element: string;
  context: string;
  position: number;
  errorStatusBannerKey?: string;
};

export const useErrorHandler = (): UseErrorHandlerReturn => {
  const { setStatusBanner } = useSearchAndShuffleContext();
  const { trackErrorShown } = useJobCardTracking();

  const triggerError = async ({
    element,
    context,
    position,
    errorStatusBannerKey,
  }: ErrorParams): Promise<void> => {
    trackErrorShown({
      element,
      context,
      position,
    });
    if (errorStatusBannerKey) {
      setStatusBanner({
        show: true,
        type: 'error',
        key: errorStatusBannerKey,
      });
    }
  };

  return {
    triggerError,
  };
};
